<template>
  <div :class="`accordion ${open ? 'open' : ''}`" @click="open = !open">
    <div class="question">
      <slot name="question"></slot>
      <div class="icon">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#09373D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M5 10H15" />
          <path v-if="!open" d="M10 15L10 5" stroke="#09373D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
    <transition
      name="accordion"
      @before-enter="beforeEnter"
      @enter="enter"
      @before-leave="beforeLeave"
      @leave="leave"
    >
      <div v-show="open" class="answer">
        <slot name="answer"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data: () => ({
    open: false,
  }),
  methods: {
    beforeEnter (el) {
      console.log(el, 'eeeel')
      el.style.height = '0'
    },
    enter (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    beforeLeave (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    leave (el) {
      el.style.height = '0'
    },
  },
}
</script>

<style lang="scss">
.accordion {
  padding: 12px 12px 12px 24px;
  border-radius: 12px;
  border: 1px solid var(--Secondary-Button-Stroke);
  background: var(--Basic-White);
  display: flex;
  flex-direction: column;
  gap: 16px;
  cursor: pointer;
  p {
    margin: 0;
    color: var(--Primary-Shades-Primary);
    font-size: 16px;
  }

  .question {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      min-width: 40px;
      height: 40px;
      border-radius: 8px;
      border: 1px solid var(--Secondary-Button-Stroke);
      background: var(--Basic-White);
      margin-left: 8px;
    }
    p {
      font-weight: 600;
      line-height: 20px;
    }
  }
  .answer {
    transition: 150ms ease-out;
    overflow: hidden;
  }
}
.accordion .open {
  background: #FFFFFF;
  padding: 12px 12px 24px 24px;
  .question p {
    color: #000000 !important;
  }
}
</style>
